import client from './client';

export interface AnalyticsDashboard {
  users: {
    total: number;
    new_today: number;
    new_week: number;
    new_month: number;
  };
  appeals: {
    total: number;
    pending: number;
    in_progress: number;
    resolved: number;
    avg_resolution_hours: number;
  };
  news: {
    total: number;
    published_week: number;
  };
  directory: {
    total: number;
    with_location: number;
  };
  shutoffs: {
    active: number;
    upcoming: number;
  };
  polls?: {
    active: number;
    total_votes: number;
  };
  [key: string]: any;
}

export interface WeeklyReport {
  period: { start: string; end: string };
  users: any;
  appeals: any;
  news: any;
  shutoffs: any;
  [key: string]: any;
}

export const analyticsApi = {
  dashboard: () =>
    client.get<AnalyticsDashboard>('/api/admin/analytics/dashboard'),

  weeklyReport: () =>
    client.get<WeeklyReport>('/api/admin/analytics/weekly-report'),

  weeklyReportPdf: () =>
    client.get('/api/admin/analytics/weekly-report/pdf', { responseType: 'blob' }),
};
